import React, { useState } from 'react';

const SelectWithSearch = ({
    options,
    value,
    onChange,
    label,
    placeholder,
    displayField
}) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [isOpen, setIsOpen] = useState(false);

    // que acepte ID o id
    const getOptionId = (option) => {
        return option?.id ?? option?.ID;
    };

    const getValueId = (val) => {
        return val?.id ?? val?.ID;
    };

    const filteredOptions = options.filter((option) => {
        const displayValue = option[displayField];
        return (
            typeof displayValue === "string" &&
            displayValue.toLowerCase().includes(searchTerm.toLowerCase())
        );
    });

    const selectedOption = value
        ? options.find(
            (option) => String(getOptionId(option)) === String(getValueId(value))
        )
        : null;


    return (
        <div className="relative">
            {label && <label className="block mb-2">{label}</label>}
            <div
                className="border border-gray-300 rounded p-2 cursor-pointer"
                onClick={() => setIsOpen(!isOpen)}
            >
               {selectedOption
                    ? selectedOption[displayField]
                    : placeholder}
            </div>
            {isOpen && (
                   <div className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded shadow-lg">
                    {/* input buscar */}
                    <input
                        type="text"
                        placeholder="Buscar..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="block w-full p-2 border-b border-gray-300"
                    />

                    {/* lista de resultados */}
                    <div className="max-h-40 overflow-y-auto">
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map((option) => (
                                <div
                                    key={getOptionId(option)} 
                                    onClick={() => {
                                        onChange(option);     
                                        setIsOpen(false);
                                        setSearchTerm("");
                                    }}
                                    className="p-2 hover:bg-gray-200 cursor-pointer"
                                >
                                    {option[displayField]}
                                </div>
                            ))
                        ) : (
                            <div className="p-2 text-gray-500">No hay opciones</div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SelectWithSearch;
